export default (opts = {}) => {
    const component = {
        model: {
            defaults: {
              type:'Container', 
              name: 'Container Parceiros',
              attributes: { class: 'container-cubo' },
              components: [
                {
                  type: 'rowPartners1', 
                },
                
              ],
              styles: `
             .container-cubo{
                max-width: 1600px; 
             }
            `,
             },
          },
          view: {
      
          },
};
  return component; 
};